import { ArrowDownTrayIcon, DocumentIcon } from '@heroicons/react/24/outline';
import type { ChangeOrderApprovalsResponse } from '@/api/Sherpa/ChangeOrder';
import { capitalize } from '@/utils';

type AssetFile = ChangeOrderApprovalsResponse['data'][0]['approvalAsset'][0];

export function ApprovalDetails({ files, uploadedBy }: { files: AssetFile[]; uploadedBy: string }) {
  const handleDownload = (file: AssetFile) => {
    fetch(file?.assetUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      });
  };

  return (
    <>
      {files?.map((document) => {
        return (
          <div key={document.key}>
            <div className='flex py-3 gap-2 border-t-2'>
              <DocumentIcon className='w-10 h-10 flex-none' />
              <div className='flex flex-col gap-1 shrink overflow-hidden'>
                <p className='truncate'>{capitalize(document?.name)}</p>
                {uploadedBy && <span className='text-neutralColor-normal text-xs'>Uploaded By: {uploadedBy}</span>}
              </div>
              <div className='grow'>
                <ArrowDownTrayIcon onClick={() => handleDownload(document)} className='w-5 h-5 cursor-pointer hover:text-blue-400' />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
